// =============================================================================
// INITIAL NODES
// =============================================================================
const getInitialNodes = (agentName = 'Novo Agente') => [
  {
    id: 'start-1',
    type: 'start',
    position: { x: 400, y: 50 },
    data: { label: 'Início', agentName },
    deletable: false,
  },
  {
    id: 'end-1',
    type: 'end',
    position: { x: 400, y: 500 },
    data: { label: 'Fim', key: 'end' },
    deletable: false,
  },
];

export default getInitialNodes;
